export enum ArvorePosicaoEnum {
    ESQUERDA = 'ESQUERDA',
    DIREITA = 'DIREITA',
}
